import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFetch } from "@/lib/hooks";
import { fmtDate } from "@/lib/format";
import { Empty, Loading, PageHeader, Panel, StatusBadge, Table, cellCls, rowCls } from "@/components/common";

const FILTERS = [["", "Tous"], ["a_faire", "À faire"], ["en_cours", "En cours"], ["termine", "Attente CQ"], ["qc_ok", "CQ validé"], ["cloture", "Clôturés"]];

export default function Orders() {
  const [status, setStatus] = useState("");
  const nav = useNavigate();
  const { data, loading } = useFetch<any[]>(`/orders?status=${status}`);
  return (
    <div>
      <PageHeader eyebrow="Atelier" title="Ordres de réparation" />
      <div className="mb-4 flex flex-wrap gap-2">
        {FILTERS.map(([v, l]) => (
          <button key={v} onClick={() => setStatus(v)} className={`h-9 rounded-sm border px-4 text-sm transition-colors ${status === v ? "border-primary bg-primary/10" : "border-border hover:bg-accent"}`} data-testid={`orders-filter-${v || "all"}`}>{l}</button>
        ))}
      </div>
      <Panel>
        {loading ? <Loading /> : !data?.length ? <Empty text="Aucun OR" /> : (
          <Table head={["N°", "Véhicule", "Client", "Mécanicien", "Tâches", "Ouvert", "Statut"]} testId="orders-table">
            {data.map((o) => (
              <tr key={o.id} className={rowCls} onClick={() => nav(`/or/${o.id}`)} data-testid={`order-row-${o.id}`}>
                <td className={`${cellCls} font-mono-data font-semibold`}>{o.number}</td>
                <td className={cellCls}><span className="font-mono-data">{o.plate}</span> <span className="text-xs text-muted-foreground">{o.vehicle_label}</span></td>
                <td className={cellCls}>{o.client_name}</td>
                <td className={cellCls}>{o.mechanic_name || <span className="text-amber-400">Non affecté</span>}</td>
                <td className={`${cellCls} font-mono-data`}>{o.tasks.filter((t: any) => t.done).length}/{o.tasks.length}</td>
                <td className={`${cellCls} text-muted-foreground`}>{fmtDate(o.created_at)}</td>
                <td className={cellCls}><StatusBadge status={o.status} /></td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
